import { Text, Image, Box, Button } from '@chakra-ui/react';
import { formatToMXN } from '../util/util';
import { useTranslation } from 'react-i18next';

const Offers = ({ offer, onClick, checkin, checkout, handleBack }) => {

  const { t } = useTranslation();

  return (
    <Box
      width={'auto'}
      backgroundColor="gray.100"
      p={2}
      borderRadius="5"
      my={2}
    >
      <div className="overflow-auto d-flex flex-column">
        <Text>{offer.title}</Text>
        <Text>{t('PRICE')} {formatToMXN(offer.total_price)}</Text>
        <Image src={offer.photo} />
        <Text>{t('INCLUDES')} {offer.meal_plan}</Text>
        <Text>{t('MAX_PEOPLE')} {offer.max_occupancy}</Text>
        <Text mt={"3"}>{t('CHECKIN')} {checkin}</Text>
        <Text>{t('CHECKOUT')} {checkout}</Text>
        <Text mt={12} fontWeight={"bold"}>{t('CANCELLATION_POLICY')}:</Text>
        <Text mt={2}>{offer.translations.es.cancellation_policy}</Text>
        <div className="d-flex justify-content-between">
          <Button
            onClick={() => onClick(offer)}
            className="my-4"
            colorScheme={'orange'}
          >
            {t('SELECT')}
          </Button>
        </div>
      </div>
    </Box>
  );
};

export default Offers;
